import { SafeResourceUrl } from "@angular/platform-browser";

export class ItemGaleryModel {
    name!: string;
    type!: string;
    file!: File | null;
    prev!: SafeResourceUrl;
    id?: number;
    portada!: boolean;
    index?: number;
}